import type { InterventionDuplicateButtonProps } from "./intervention-duplicate-button.type";

import { ModelDuplicateButton } from "@/modules/model-duplicate";

import { InterventionDuplicateForm } from "../intervention-duplicate-form";

const InterventionDuplicateButton = ({
  intervention,
  ...buttonProps
}: InterventionDuplicateButtonProps) => {
  return (
    <ModelDuplicateButton
      {...buttonProps}
      modelKey="intervention"
      form={<InterventionDuplicateForm intervention={intervention} />}
    />
  );
};

export default InterventionDuplicateButton;
